import { graphql } from '@/generated/gql';

export const DEMAND_CONVERSATION_SETTINGS_CREATE_MUTATION = graphql(/* GraphQL */ `
  mutation DemandConversationSettingsCreate($data: SvbrgConversationSettingsCreateMutation!) {
    sevenbridges {
      conversationSettings {
        create(data: $data) {
          id
          entityId
          entityVariant
          tools {
            id
            isEnabled
          }
          quickActions {
            id
            prompt
            translations {
              id
              language
              text
              variant
            }
            isConversationStarter
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`);
